<section>

  <!-- Expertise -->
  <div class="flex justify-between mb-8">
    <h2 class="text-xl text-secondary-900 dark:text-white font-semibold">Expertise</h2>
    <app-edit-button *ngIf="edit" [edit]="edit"></app-edit-button>
  </div>
  <!-- / Expertise -->

  <!-- Role -->
  <div *ngIf="company" class="mb-8">
    <app-assistant-prompt
      tag="ASK_ASSISTANT_C_LEVEL"
      title="Personal interests"
      [type]="'role'"
      [company]="company"
      [reportId]="reportSearch?.id"
      [options]="['Execution', 'Implementation', 'Planning', 'C-Level', 'Senior Manager']">
    </app-assistant-prompt>
  </div>

  <!-- Business interests -->
  <div *ngIf="company" class="mb-8">
    <h3 class="text-md font-semibold mb-4">Business interests</h3>
    <app-assistant-prompt tag="ASK_ASSISTANT_C_LEVEL"
                          title="Personal interests"
                          [type]="'role-2'"
                          [company]="company"
                          [reportId]="reportSearch?.id">
    </app-assistant-prompt>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 mb-6">

    <!-- Areas of Expertise -->
    <div class="second-card relative">
      <div class="px-6 pt-6 pb-4">
        <h3 class="text-base font-semibold uppercase">Areas of expertise</h3>
      </div>
      <div class="h-56 max-h-56">
        <app-area-of-expertise [company]="company"></app-area-of-expertise>
      </div>
    </div>

    <!-- Person Job Types by Department -->
    <div class="second-card relative">
      <div class="px-6 pt-6 pb-4">
        <h3 class="text-base font-semibold uppercase">Person job types by department</h3>
      </div>
      <div class="h-56 max-h-56">
        <app-department-job-types [company]="company"></app-department-job-types>
      </div>
    </div>

    <!-- Management Experience & Years in Current Company -->
    <div class="flex flex-col gap-6 h-full">
      <div class="second-card flex-1 flex flex-col justify-between p-6">
        <h3 class="text-base font-semibold uppercase pb-6">Management experience</h3>
        <app-assistant-prompt *ngIf="company" tag="ASK_ASSISTANT_TOTAL_BUSINESS_TENURE"
                              [type]="'years'"
                              [company]="company">
        </app-assistant-prompt>
      </div>

      <div class="second-card flex-1 flex flex-col justify-between p-6">
        <h3 class="text-base font-semibold uppercase pb-6">Years in current company</h3>
        <app-assistant-prompt *ngIf="company" tag="ASK_ASSISTANT_YEARS_IN_CURRENT_COMPANY"
                              [type]="'years'"
                              [company]="company">
        </app-assistant-prompt>
      </div>
    </div>

  </div>

  <div class="grid lg:grid-cols-2 xl:grid-cols-3 gap-6">

    <!-- Insights about career -->
    <div>
      <div *ngIf="company" class="relative blue-card h-44 p-3">

        <h3 class="text-base font-semibold pb-4">Insights about career</h3>
        <app-assistant-prompt tag="ASK_ASSISTANT_INSIGHTS_ABOUT_CAREER"
                              title="Insights about career"
                              type="insights"
                              [company]="company"
                              [showButton]="true"
                              [buttonType]="2"
                              [class]="'text-sm line-clamp-3'">
        </app-assistant-prompt>

      </div>
    </div>
    <!-- / Insights about career -->

    <!-- Exploratory email example -->
    <div>
      <div *ngIf="company" class="relative blue-card h-44 p-3">

        <h3 class="text-base font-semibold pb-4">Exploratory email example</h3>
        <app-assistant-prompt tag="ASK_ASSISTANT_EXPLORATORY_EMAIL_EXAMPLE"
                              title="Exploratory email example"
                              [type]="'exploratory-email'"
                              [company]="company"
                              [showButton]="true"
                              [buttonType]="2"
                              [class]="'text-sm line-clamp-3'">
        </app-assistant-prompt>

      </div>
    </div>
    <!-- / Exploratory email example -->

    <!-- Basic words in local language -->
    <div>
      <div *ngIf="company" class="relative blue-card h-44 p-3">

        <h3 class="text-base font-semibold pb-4">Basic words in local language</h3>
        <app-assistant-prompt tag="ASK_ASSISTANT_BASIC_WORDS_IN_LOCAL_LANGUAGE"
                              title="Basic words in local language"
                              [type]="'basic_words'"
                              [company]="company"
                              [showButton]="true"
                              [buttonType]="2"
                              [class]="'text-sm line-clamp-3'">
        </app-assistant-prompt>

      </div>
    </div>
    <!-- / Basic words in local language -->

  </div>

  <!--
  <div class="grid grid-cols-4 gap-6 mt-8">

    <div class="col-span-4 lg:col-span-4 xl:col-span-2">
      <h3 class="text-base font-semibold pb-6">Areas of expertise</h3>

      <ng-template *ngIf="areas_of_expertise?.series?.length === 0">
        <p>N/A</p>
      </ng-template>
      <div id="areas-of-expertise-chart"></div>
    </div>

    <div class="col-span-4 lg:col-span-2 xl:col-span-1">
      <h3 class="text-base font-semibold pb-6">Management experience</h3>
      <div *ngIf="company" class="mb-3">

        <app-assistant-prompt tag="ASK_ASSISTANT_MANAGEMENT_EXPERIENCE"
                              [type]="'years'"
                              [company]="company">
        </app-assistant-prompt>

      </div>
    </div>

    <div class="col-span-4 lg:col-span-2 xl:col-span-1">
      <h3 class="text-base font-semibold pb-6">Total business tenure</h3>
      <div *ngIf="company" class="mb-3">

        <app-assistant-prompt tag="ASK_ASSISTANT_TOTAL_BUSINESS_TENURE"
                              [type]="'years'"
                              [company]="company">
        </app-assistant-prompt>

      </div>

      <div class="mb-3">
        <span class="text-sm">Seniority:</span> <br />
        <span class="font-semibold">{{reportSearch?.search_person?.enhanced_data?.seniority ?? ''}}</span>
      </div>

      <div class="mb-3" *ngIf="reportSearch?.person?.enhanced_data?.subdepartments">
        <span class="text-sm">Experienced as:</span> <br />
        <div *ngFor="let experience of reportSearch?.search_person.enhanced_data.subdepartments;" class="pills">
          <span class="flex items-center text-xs text-secondary-900">
            {{ experience }}
          </span>
        </div>
      </div>

    </div>

    <div class="col-span-4 lg:col-span-2 xl:col-span-1">
      <h3 class="text-base font-semibold pb-6">Years in current company</h3>
      <div *ngIf="company" class="mb-3">

        <app-assistant-prompt tag="ASK_ASSISTANT_YEARS_IN_CURRENT_COMPANY"
                              [type]="'years'"
                              [company]="company">
        </app-assistant-prompt>

      </div>
    </div>

  </div>
  -->

</section>
